import { z } from "zod";

export const platformSettingFormSchema = z.object({
  type: z.string(),
  key: z.string(),
  value: z.string().min(1, "Value is required"),
  description: z.string().optional(),
  tenantId: z.string().optional(),
  region: z.string().optional(),
  isActive: z.boolean(),
});

export type PlatformSettingFormData = z.infer<typeof platformSettingFormSchema>;
